import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'

import CountriesTableSkeleton from './CountriesTableSkeleton/CountriesTableSkeleton'
import CountryRow from './CountryRow/CountryRow'
import TableHeader from './TableHeader/TableHeader'
import * as Styles from './styles'

const CountriesTable = ({ loading, countries, columns, onSort, orderBy, onClickCountry, selectedCountry }) => {
  if (loading) return <CountriesTableSkeleton />
  if (!countries?.length) return <NoResultsFound />

  return (
    <Styles.Container>
      <Styles.Table>
        <TableHeader columns={columns} onSort={onSort} orderBy={orderBy} />
        <tbody>
          {countries.map((country, index) => (
            <CountryRow
              key={country.country_code}
              country={country}
              columns={columns}
              index={index + 1}
              onClick={onClickCountry}
              selected={selectedCountry === country.country_code}
            />
          ))}
        </tbody>
      </Styles.Table>
    </Styles.Container>
  )
}

export default CountriesTable
